export const handleSortByTime = (
    sortOrder, setSortOrder,
    employeeTable, setEmployeeTable
) => {

    const newOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newOrder);

    const parseTime = (timeStr) => {
        if (!timeStr || timeStr === "-" || timeStr.trim() === "") return null;

        let time = timeStr.trim();
        const hasAMPM = time.toLowerCase().includes("am") || time.toLowerCase().includes("pm");

        if (hasAMPM) {
            const [t, period] = time.toLowerCase().split(" ");
            let [h, m] = t.split(":");
            h = parseInt(h, 10);

            if (period === "pm" && h < 12) h += 12;
            if (period === "am" && h === 12) h = 0;

            return new Date(1970, 0, 1, h, m);
        }

        const parts = time.split(":");
        const h = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10);

        return new Date(1970, 0, 1, h, m);
    };

    const sorted = [...employeeTable.records].sort((a, b) => {
        const timeA = parseTime(a.attendanceTime);
        const timeB = parseTime(b.attendanceTime);

        if (timeA === null && timeB !== null) return 1;
        if (timeA !== null && timeB === null) return -1;
        if (timeA === null && timeB === null) return 0;

        return newOrder === "asc" ? timeA - timeB : timeB - timeA;
    });

    setEmployeeTable(prev => ({
        ...prev,
        records: sorted,
    }));
};


export  const handleSortByTimeDirectArray = (
    sortOrder, setSortOrder,
    records, setRecords
) => {

    const newOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newOrder);

    const parseTime = (timeStr) => {
        if (!timeStr || timeStr === "-" || timeStr.trim() === "") return null;

        let time = timeStr.trim();
        const hasAMPM = time.toLowerCase().includes("am") || time.toLowerCase().includes("pm");

        if (hasAMPM) {
            const [t, period] = time.toLowerCase().split(" ");
            let [h, m] = t.split(":");
            h = parseInt(h, 10);

            if (period === "pm" && h < 12) h += 12;
            if (period === "am" && h === 12) h = 0;

            return new Date(1970, 0, 1, h, m);
        }

        const parts = time.split(":");
        return new Date(1970, 0, 1, parseInt(parts[0], 10), parseInt(parts[1], 10));
    };

    const sorted = [...records].sort((a, b) => {
        const timeA = parseTime(a.attendanceTime);
        const timeB = parseTime(b.attendanceTime);

        // Push null or "-" last (same for asc / desc)
        if (timeA === null && timeB !== null) return 1;
        if (timeA !== null && timeB === null) return -1;
        if (timeA === null && timeB === null) return 0;

        return newOrder === "asc" ? timeA - timeB : timeB - timeA;
    });

    setRecords(sorted);
};
